/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { BarChartAdvanced, Spinner } from "vr-react-components";
import { getPlaceholderData } from "../update/updateCenterGraph";
import { handleSetLockControl } from "../handlers/PrivateHandlers";
import { handleSetRotation, handleSetZoom } from "../handlers/CenterChartHandlers";

const CenterChart = React.memo(({ width, height, depth }) => {
    const centerGraph = useSelector((state) => state.centerGraph);
    const device = useSelector((state) => state.private.device);
    const manipulation = useSelector((state) => state.centerGraph.isManipulable.settings);
    const isLoading = useSelector((state) => state.centerGraph.isLoading);
    const canModify = useSelector((state) => state.private.device.canModify);

    const isGraphFilled = centerGraph.data.hasOwnProperty('values', 'xLabels', 'zLabels')
        && centerGraph.data.values.some(arr => arr.some(item => item !== 0));

    const barChartData = isGraphFilled ? centerGraph
            : getPlaceholderData({ ...centerGraph, data: { ...centerGraph.data } })

    return isLoading ? (
        <Spinner radius={0.4} position="0 0.5 0" />
    ) : (
        <BarChartAdvanced
            width={width}
            height={height}
            depth={depth}
            data={barChartData}
            deviceData={device}
            manipulationData={manipulation}
            setZoom={handleSetZoom}
            setRotation={handleSetRotation}
            aframeClasses={canModify ? "collidable" : ""}
            setLockControls={(callback) => {
                if (isGraphFilled) handleSetLockControl(callback);
            }}
        />
    );
});

export default CenterChart;
